import React from 'react';
import InputField from 'commons/components/FormFields/InputField';

interface FormikInputFieldProps {
    /** props passed to the field */
    field: any,
    /** props related to the formik form such as errors and touched flags */
    form: any,
    /** onChange of the field */
    onChange: React.ChangeEventHandler
}

function FormikInputField(props: FormikInputFieldProps) {

    const field = props.field;

    return (
        <InputField
            {...field}
            {...props}
            error={props.form.errors[field.name]}
            name={field.name}
            onChange={(e: React.ChangeEvent) => { if (props.onChange) props.onChange(e); field.onChange(e); }}
            touched={props.form.touched[field.name]}
        />
    );

}

export default FormikInputField;